<app-nav></app-nav>
<app-cookies></app-cookies>
<app-live-update></app-live-update>
<router-outlet></router-outlet>
<app-footer></app-footer>